import React from 'react';
import { Empty } from 'antd';
import Styles from './EmptyState.module.scss';

interface EmptyStateProps {
    /** Description text */
    description?: string;
    /** Custom image */
    image?: React.ReactNode;
    /** Use simple image */
    simple?: boolean;
    /** Full height container */
    fullHeight?: boolean;
    /** Custom className */
    className?: string;
    /** Custom style */
    style?: React.CSSProperties;
}

/**
 * Reusable empty state component with centered layout
 */
export default function EmptyState({
    description = 'No data available',
    image,
    simple = false,
    fullHeight = false,
    className,
    style,
}: EmptyStateProps) {
    const containerClass = `${Styles.container} ${fullHeight ? Styles.fullHeight : ''} ${className || ''}`.trim();

    return (
        <div
            className={containerClass}
            style={style}
        >
            <Empty
                description={description}
                image={image || (simple ? Empty.PRESENTED_IMAGE_SIMPLE : undefined)}
            />
        </div>
    );
}
